import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, Plus } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { toast } from 'sonner';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product, 1);
    toast.success(`${product.name} ajouté au panier`);
  };

  return (
    <Link
      to={`/products/${product.id}`}
      className="product-card group block"
      data-testid={`product-card-${product.id}`}
    >
      {/* Image Container */}
      <div className="product-image-container relative bg-surface">
        <img
          src={product.image}
          alt={product.name}
          className="product-image"
          loading="lazy"
        />
        
        {/* Quick Add Button */}
        <button
          onClick={handleAddToCart}
          className="absolute bottom-4 right-4 w-12 h-12 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-rose opacity-0 group-hover:opacity-100 transition-all duration-300 hover:bg-accent hover:text-white"
          data-testid={`quick-add-${product.id}`}
        >
          <Plus className="w-5 h-5" />
        </button>

        {/* Featured Badge */}
        {product.featured && (
          <span className="absolute top-4 left-4 bg-accent text-white text-xs uppercase tracking-widest px-3 py-1">
            Coup de cœur
          </span>
        )}
      </div>

      {/* Product Info */}
      <div className="p-4">
        <h3 className="font-serif text-lg text-text-primary group-hover:text-accent transition-colors">
          {product.name}
        </h3>
        <p className="text-text-secondary text-sm mt-1">
          {product.fragrance} • {product.volume}
        </p>
        <p className="text-accent font-medium mt-2">
          {product.price.toFixed(2)} €
        </p>
      </div>
    </Link>
  );
};

export default ProductCard;
